.form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.sent {
  padding: 12px 14px;
  border: 1.5px solid var(--ink);
  border-radius: var(--radius-control);
  background: var(--accent-soft);
  font-size: 15px;
  font-weight: 600;
}
